import { render, staticRenderFns } from "./WorkflowNotice.vue?vue&type=template&id=8aa2ba2c&scoped=true"
import script from "./WorkflowNotice.vue?vue&type=script&lang=js"
export * from "./WorkflowNotice.vue?vue&type=script&lang=js"
import style0 from "./WorkflowNotice.vue?vue&type=style&index=0&id=8aa2ba2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa2ba2c",
  null
  
)

export default component.exports